import { Button, Card, Divider, Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { RouterLink } from '../../../../../routes/components';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SectionActivityHeroMeta, SectionActivityTopBarMeta } from './SectionActivityMeta';
import { SectionFeatureFlags } from './SectionFeatureFlags';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';

export default function BlindBoxActivityBasicList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-activity-basic" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        {/*<CustomBreadcrumbs*/}
        {/*  heading={t('module.blindBox.activityBasic')}*/}
        {/*  links={ [*/}
        {/*    { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },*/}
        {/*    { name: t('module.blindBox.activityBasic') },*/}
        {/*  ]}*/}
        {/*  action={*/}
        {/*    <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>*/}
        {/*      {t('module.blindBox.refreshAll')}*/}
        {/*    </Button>*/}
        {/*  }*/}
        {/*/>*/}
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <SectionActivityHeroMeta refreshKey={refreshKey} />
          </Card>
          {/*<Card variant="outlined" sx={SECTION_CARD_SX}>*/}
          {/*  <SectionActivityTopBarMeta refreshKey={refreshKey} />*/}
          {/*</Card>*/}
          <Card variant="outlined" sx={SECTION_CARD_SX}>
            <SectionFeatureFlags refreshKey={refreshKey} />
          </Card>
          {/*<Card variant="outlined" sx={SECTION_CARD_SX}>*/}
          {/*  <SectionRuntimeConfigs*/}
          {/*    refreshKey={refreshKey}*/}
          {/*    excludeKeys={[*/}
          {/*      'activity_title',*/}
          {/*      'activity_subtitle',*/}
          {/*      'activity_cta_text',*/}
          {/*      'navbar_title',*/}
          {/*      'back_button_text',*/}
          {/*    ]}*/}
          {/*  />*/}
          {/*</Card>*/}
        </Stack>
      </DashboardContent>
    </PermissionGuard>
  );
}
